import React from 'react';
import './App.css';
import AvatarComponent from './components/AvatarComponent';
import LegalDisclaimer from './components/LegalDisclaimer';
import DashboardPage from './components/DashboardPage';
import VersionPage from './components/VersionPage';
import TermsOfServicePage from './components/TermsOfServicePage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';

function App() {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  const normalized =
    pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  if (
    normalized === '/admin' ||
    normalized === '/dashboard' ||
    normalized === '/conversations' ||
    normalized === '/dashboard/feedback' ||
    normalized === '/dashboard/admins' ||
    normalized === '/dashboard/config'
  ) {
    return <DashboardPage />;
  }
  if (pathname === '/version') return <VersionPage />;
  if (pathname === '/terms') return <TermsOfServicePage />;
  if (pathname === '/privacy') return <PrivacyPolicyPage />;
  if (pathname === '/terms-of-service') return <TermsOfServicePage />;
  if (pathname === '/privacy-policy') return <PrivacyPolicyPage />;

  return (
    <div className="App">
      <main>
        <AvatarComponent />
      </main>
      <LegalDisclaimer variant="footer" />
    </div>
  );
}

export default App;
